import React, { useState, useEffect } from "react";
import axios from "axios";
import Qrcode from "qrcode.react";
import { api } from "@/services/api";
import { getToken } from "@/services/auth";
import ShimmerEffect from "@/components/Shimmer";

import { Container } from "./styles";

export const Cupons = () => {
	const [modalQrCode, setModalQrCode] = useState(false);
	const [modalSubmitQrCode, setModalSubmitQrCode] = useState(false);
	const [data, setData] = useState(null);
	const [cupom, setCupom] = useState("");
	const loadElements = [];

	for (let index = 0; index < 12; index++) {
		loadElements.push(index);
	}

	function hadleToogleQrCode(cupom) {
		setModalQrCode(!modalQrCode);
		setCupom(cupom);
	}

	function handleToogleSubmitQrCode(cupom) {
		setModalSubmitQrCode(!modalSubmitQrCode);
		setCupom(cupom);
	}

	useEffect(() => {
		const CancelToken = axios.CancelToken; // instância do CancelToken
		const source = CancelToken.source(); // instância do source, onde está contido o token de cancelamento

		const loadData = () => {
			api.get("consumer/coupons", {
				cancelToken: source.token,
				params: { type: "list" },
				headers: {
					Authorization: `Bearer ${getToken()}`,
				},
			})
				.then((res) => {
					setData(res?.data);
				})
				.catch((error) => {
					console.warn({ endPoint: "consumer/coupons", error });
				});
		};

		loadData();

		// retorna uma função com a finalidade fazer o cancelamento
		return () => {
			source.cancel();
		};
	}, []);

	return (
		<Container>
			<h2>Histórico de cupons gerados</h2>
			<ul className='cupons'>
				{data
					? data?.coupons.map((cupom, index) => (
							<li key={index}>
								<header>
									<p className='cupomSerie'>
										<strong>Cupom Nº:</strong> {cupom.code}
									</p>
									<p className='cupomDate'>
										<strong>
											{cupom.created_in
												.split("-")
												.reverse()
												.join("/")}
										</strong>
									</p>
								</header>
								<div className='cupomInfo'>
									<div className='animal'>
										<p className='name'>{cupom.pet}</p>
										<p className='status'>
											{cupom.validated}
										</p>
										<p className='validate'>
											Válido até{" "}
											{cupom.valid_until
												.split("-")
												.reverse()
												.join("/")}
										</p>
									</div>
									{cupom.situation === "Cupom Disponível" ? (
										<div className='action'>
											<img
												loading='lazy'
												onClick={() =>
													hadleToogleQrCode(
														cupom.code,
													)
												}
												src={
													require("@/assets/img/icon-qrcode-list.svg")
														.default
												}
												alt=''
											/>
											<img
												loading='lazy'
												onClick={() =>
													handleToogleSubmitQrCode(
														cupom.code,
													)
												}
												src={
													require("@/assets/img/icon-share-list.svg")
														.default
												}
												alt=''
											/>
										</div>
									) : (
										""
									)}
								</div>
							</li>
					  ))
					: loadElements.map((_, index) => (
							<li key={index}>
								<header>
									<div
										style={{ margin: "2px 0" }}
										className='cupomSerie'>
										<ShimmerEffect
											width={185}
											height={20}
										/>
									</div>
									<div
										style={{ margin: "2px 0" }}
										className='cupomDate'>
										<ShimmerEffect width={85} height={20} />
									</div>
								</header>
								<div className='cupomInfo'>
									<div className='animal'>
										<div
											style={{ margin: "2px 0" }}
											className='name'>
											<ShimmerEffect
												width={150}
												height={20}
											/>
										</div>
										<div
											style={{ margin: "2px 0" }}
											className='status'>
											<ShimmerEffect
												width={150}
												height={20}
											/>
										</div>
										<div
											style={{ margin: "2px 0" }}
											className='validate'>
											<ShimmerEffect
												width={185}
												height={20}
											/>
										</div>
									</div>
								</div>
							</li>
					  ))}
			</ul>

			<div
				className='modal'
				style={{ display: `${modalQrCode ? "block" : "none"}` }}>
				<div className='content'>
					<img
						loading='lazy'
						className='close'
						onClick={() => hadleToogleQrCode("")}
						src={
							require("@/assets/img/Icon ionic-ios-close.png")
								.default
						}
						alt='icone close'
					/>
					<Qrcode value={cupom} size={168} renderAs='svg' />
				</div>
			</div>

			<div
				className='modal'
				style={{ display: `${modalSubmitQrCode ? "block" : "none"}` }}>
				<div className='content'>
					<img
						loading='lazy'
						className='close'
						onClick={() => handleToogleSubmitQrCode("")}
						src={
							require("@/assets/img/Icon ionic-ios-close.png")
								.default
						}
						alt='icone close'
					/>
					<form className='form'>
						<input
							type='text'
							placeholder='Insira o email da loja'
						/>
						<button className='btn-primary'>
							Enviar por e-mail
						</button>
					</form>
				</div>
			</div>
		</Container>
	);
};

export default Cupons;
